module.exports = __webpack_public_path__ + "815967c2772f324450a0277a97d7d4dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/canada_logo.svg
// module id = 230
// module chunks = 0